import React from 'react';
import PropTypes from 'prop-types';

import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';
import TypeaheadField from '../../../design/shared/form/typeaheadField';

const Dealership = ({
  label,
  errors,
  touched,
  dealerships,
  setFieldValue,
  setFieldTouched
}) => {
  return (
    <TypeaheadField
      label={label}
      errors={errors}
      touched={touched}
      name="dealership"
      id="dealership"
      list={dealerships}
      val="name"
      errorIcon={ErrorIcon}
      setFieldValue={value => {
        setFieldValue('dealership', value, true);
      }}
      setFieldTouched={setFieldTouched}
      required
    />
  );
};

Dealership.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    dealership: PropTypes.string
  }).isRequired,
  touched: PropTypes.shape({
    dealership: PropTypes.bool
  }).isRequired,
  dealerships: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    })
  ).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

export default Dealership;
